import { FC } from "react";
import { FiltersBar } from "../components";
import { useHotelsListingContext } from "../context/HotelsListingContext";
import HotelList from "../components/HotelList/HotelList";
import { MainSearch } from "../../../Components";
import { Hotel } from "src/store/apis/Hotels";
import SearchProgressBar from "src/Modules/Hotels/Components/SearchProgressBar/SearchProgressBar";
import SortersBar from "../components/SortersBar/SortersBar";
import CountdownTimerSlider from "../../../Components/CountdownTimerSlider/CountdownTimerSlider";
import classNames from "classnames";

const HotelsListingWeb: FC<{
  fullDataGroups: any;
  hotels: Hotel[];
  filteredDataGroups: any;
}> = ({
  fullDataGroups,
  hotels,
  filteredDataGroups,
}) => {
  const { isPollingDone, hasFirstResults, searchObject } = useHotelsListingContext();
  const hasHotels = !isPollingDone || hotels.length > 0;
  return (
    <div className="bg-background-default flex flex-col">
      <div className="border-border-default border-b p-3 shadow-md lg:px-4 xl:px-10">
        <MainSearch initialValues={searchObject} />
      </div>
      <div className="sticky top-0 z-10">
        <CountdownTimerSlider />
      </div>
      <div className="flex gap-1 lg:px-4 xl:gap-4 xl:px-10">
        <div className={classNames("min-w-75 flex-1", "custom-scrollbar")}>
          <div className={"sticky top-5 max-h-screen overflow-y-auto"}>
            <FiltersBar dataGroups={fullDataGroups} />
          </div>
        </div>
        <div className="flex-4 min-w-170 flex flex-col gap-4 p-4">
          {hasHotels && (
            <>
              <div className="bg-background-default sticky top-8 z-10">
                <SortersBar dataGroups={filteredDataGroups} />
              </div>
              {hasFirstResults && <SearchProgressBar isPollingDone={isPollingDone} />}
            </>
          )}
          <HotelList hotels={hotels} />
        </div>
      </div>
    </div>
  );
};

export default HotelsListingWeb;
